// Size chart modal
const openBtn = document.getElementById('open-size-chart');
const modal = document.getElementById('size-chart-modal');
const closeBtn = document.getElementById('close-size-chart');

openBtn.addEventListener('click', () => modal.classList.add('active'));
closeBtn.addEventListener('click', () => modal.classList.remove('active'));
modal.addEventListener('click', e => {
  if (e.target === modal) modal.classList.remove('active');
});